import React from "react";
import AllSubjectTopics from "../../../topics/AllSubjectTopics";


function SyllabusBio() {
  return (
    <>

      <AllSubjectTopics icon="🗺️" subject="biology" type="syllabus" book="" />

    </>
  );
}

export default SyllabusBio;